import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { MenuItem, InputLabel, Select, Button } from "@material-ui/core";
import { PlayArrow, Stop } from "@material-ui/icons";

export default function SongMenuItem(props) {
  const [songs, setSongs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [playing, setPlaying] = useState(false);
  const audioRef = useRef(null);
  const customUrlRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(process.env.REACT_APP_API_URL + "/GetSongs")
      .then((response) => {
        if (cancelled) return;
        setSongs(Array.isArray(response.data) ? response.data : []);
        setLoading(false);
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err);
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  // Reset preview whenever the dropdown selection changes.
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    if (customUrlRef.current) {
      URL.revokeObjectURL(customUrlRef.current);
      customUrlRef.current = null;
    }
    setPlaying(false);
  }, [props.baseSong]);

  const resolveSongUrl = () => {
    if (!props.baseSong) return null;
    if (props.baseSong === "Custom") {
      const input = document.getElementById("customSong");
      const file = input && input.files && input.files[0];
      if (!file) return null;
      if (!customUrlRef.current) {
        customUrlRef.current = URL.createObjectURL(file);
      }
      return customUrlRef.current;
    }
    // The /GetSongs API returns scheme-less URLs (e.g. "api.geekvitations.com/uploads/audio/x.mp3"),
    // which the browser would resolve relative to the current origin. Force https.
    return /^https?:\/\//i.test(props.baseSong) ? props.baseSong : `https://${props.baseSong}`;
  };

  const togglePlay = () => {
    const url = resolveSongUrl();
    if (!url) {
      window.alert(
        props.baseSong === "Custom"
          ? "Upload a song file first to preview it."
          : "Pick a song from the dropdown first."
      );
      return;
    }
    if (!audioRef.current) return;
    if (playing) {
      audioRef.current.pause();
      setPlaying(false);
    } else {
      if (audioRef.current.src !== url) audioRef.current.src = url;
      audioRef.current.play().then(() => setPlaying(true)).catch(() => setPlaying(false));
    }
  };

  const previewDisabled = loading || !!error || !props.baseSong;

  return (
    <div className="form-row">
      <div className="form-group col-md">
        <InputLabel style={{ textAlign: "left" }}>
          Song <span style={{ color: "red" }}>*</span>
        </InputLabel>
        <div style={{ display: "flex", gap: "8px", alignItems: "stretch" }}>
          <Select
            value={props.baseSong}
            onChange={props.handleBaseSongChange}
            required
            type="text"
            variant="outlined"
            id="song"
            style={{ marginTop: 0, flex: 1 }}
            disabled={loading || !!error}
          >
            <MenuItem value="" disabled>
              <em>
                {loading
                  ? "Loading songs…"
                  : error
                  ? "Failed to load songs"
                  : "Select Song"}
              </em>
            </MenuItem>
            {songs.map((song) => (
              <MenuItem key={song.url} value={song.url}>
                {song.title}
                {song.artist ? ` - ${song.artist}` : ""}
              </MenuItem>
            ))}
            <MenuItem value={"Custom"}>Custom Song</MenuItem>
          </Select>
          <Button
            type="button"
            variant="outlined"
            onClick={togglePlay}
            disabled={previewDisabled}
            startIcon={playing ? <Stop /> : <PlayArrow />}
            style={{ color: "#1DAEE0", borderColor: "#1DAEE0", whiteSpace: "nowrap" }}
          >
            {playing ? "Stop" : "Preview"}
          </Button>
        </div>
        <audio
          ref={audioRef}
          onEnded={() => setPlaying(false)}
          onPause={() => setPlaying(false)}
          style={{ display: "none" }}
        />
      </div>
    </div>
  );
}
